import { render, staticRenderFns } from "./Cost.vue?vue&type=template&id=c4dbc3d4&"
import script from "./Cost.vue?vue&type=script&lang=ts&"
export * from "./Cost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports